/* eslint-disable jsx-a11y/anchor-is-valid */
import { CircularProgress, Tooltip } from "@mui/material";
import { useState } from "react";

import { api } from "../../../../../lib/api";

import { useAuth } from "../../../../../providers/auth";
import { IDoctorData } from "../../../../../providers/doctorsData/types";

import Modal from 'react-bootstrap/Modal';
import LoginButton from "../../../../Elements/Buttons/LoginButton";
import { usePartnerData } from "../../../../../providers/partnerData";

export interface IAgendamentoCard {
  modal: boolean;
  setModal: (val: boolean) => void;

  doctor: IDoctorData;
}

export const ConsultationRequest = ({
  modal,
  doctor,
  setModal,
}: IAgendamentoCard) => {
  const { token } = useAuth();
  const { partnerUrl } = usePartnerData();

  const [requestSucess, setRequestSucess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const onRequest = async () => {
    try {
      setLoading(true);
      const { data } = await api.post("/Contact/RequestContact", {
        idMedico: doctor.id,
      });

      if (data === "Consulta Solicitada com Sucesso") {
        setRequestSucess(true);
        setLoading(false);
        return;
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      show={modal}
      onHide={() => setModal(false)}
      backdrop="static"
      keyboard={false}
      className="text-body"
      centered
      scrollable
    >
      <div className="modal-header">
        <h5 className="modal-title">
          <i className="las la-calendar-alt me-3"></i>Confirmar
          Solicitação de Consulta
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModal(false)}
          aria-label="Close"
        ></button>
      </div>

      <div className="modal-body bg-light">
        <h6 className="text-muted text-uppercase small">Profissional:</h6>
        <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
          <div className="row align-items-center">
            <div className="col col-auto pb-3 e-0">
              <div className="img-wrap" style={{ width: 60 }}>
                <a href="#">
                  <img
                    alt={`${doctor.gender === 0 ? "Dra." : "Dr."} ${doctor.name}`}
                    src={
                      doctor.image
                        ? doctor.image
                        : doctor.gender === 0
                          ? "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbFemale.jpg"
                          : "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbMale.jpg"
                    }
                  />
                </a>
              </div>
            </div>

            <div className="col-12 col-sm pb-3">
              <h6 className="text-primary mb-1 small">
                CRM: {doctor.crm}
              </h6>
              <h5 className="mb-1">
                {doctor.gender === 0 ? "Dra." : "Dr."} {doctor.name}
                <Tooltip title="Profissional Verificado">
                  <i
                    className="las la-check-circle text-primary ms-2"
                  ></i>
                </Tooltip>
              </h5>
              <h6 className="mb-0">
                {doctor.specialty.length ? doctor.specialty[0].name : ""}
              </h6>
            </div>
          </div>
        </div>

        {requestSucess ? (
          <>
            <div>
              <div className="bg-white rounded-4 border p-3 pb-3 mb-4">
                <h5 className="mb-2 text-uppercase text-center text-success">
                  Solicitação enviada com sucesso!
                </h5>
              </div>
              <div className="bg-white rounded-4 border p-3 pb-3 mb-4">
                <h6 className="mb-2 big text-center">
                  Enviamos uma solicitação de contato para o profissional
                </h6>
              </div>
            </div>
          </>
        ) : (
          <div>
            <div className="bg-white rounded-4 border p-3 pb-3 mb-4">
              <h6 className="mb-0 text-uppercase small text-center text-danger">
                Confirme a solicitação de consulta para este profissional
              </h6>
            </div>
          </div>
        )}

        {!token ? (
          <>
            <h6 className="text-muted text-uppercase small text-center">
              Crie sua conta ou faça seu login para solicitar consulta
            </h6>
            <div className="d-flex gap-3 justify-content-center p-3">
              <LoginButton className="btn-primary">Fazer login</LoginButton>
              <a
                href={`/${partnerUrl}/user`}
                className="btn btn-success text-uppercase fw-bold"
              >
                Criar Conta
              </a>
            </div>
          </>
        ) : (
          <>
            {requestSucess ? (
              <div className="modal-footer justify-content-center">
                <h6 className="text-muted text-uppercase small text-center">
                  Aguarde o contato para agendamento da sua consulta.
                </h6>
                <div className="d-flex gap-3 justify-content-center p-3">
                  <button
                    style={{ cursor: "pointer" }}
                    onClick={() => setModal(false)}
                    className="btn btn-primary"
                  >
                    Continuar busca
                  </button>
                </div>
              </div>
            ) : (
              <div className="modal-footer justify-content-center">
                <button
                  style={{ cursor: "pointer" }}
                  onClick={onRequest}
                  className="btn btn-primary"
                >
                  {loading ? (
                    <CircularProgress size={21} color="inherit" />
                  ) : (
                    <>
                      <i className="las la-check"></i>
                      Confirmar Solicitação de Consulta
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};
